const INITIAL_STATE = {};

const model = {
  name: '@app//responseError',
  state: INITIAL_STATE, // initial state
  reducers: {
    setData(state, payload) {
      return {
        ...state,
        ...payload,
      };
    },
    getData(state) {
      return state;
    },
  },
};

export default model;
